module.exports = __webpack_public_path__ + "img/Macedonia, FYR.e5860d5a.gif";